/* eslint-disable no-param-reassign */

import React, { useEffect, useState } from 'react';

import { Button, Grid, makeStyles, Typography } from '@material-ui/core';

import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles(() => {
  return {
    instruction: {
      color: '#999999',
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: '24px',
    },
    title: {
      color: '#172B4D',
      fontSize: '20px',
      fontWeight: 'normal',
      lineHeight: '30px',
    },
  };
});
export default ({ onUpload, onUploadButtonClick, OnRequestVideo, isSubmitting$, requestButtonText, workspaceMainFileType, onOpenImagingStudySelector }) => {
  const classes = useStyles();
  const [uploadedFiles, setUploadedFiles] = useState(null);

  const handleFileChange = (evt) => {
    setUploadedFiles([...evt.target.files]);
    evt.target.value = null;
  };

  const handleUploadButtonClick = () => {
    if (onUploadButtonClick) onUploadButtonClick();
  };

  const handleOpenImagingStudySelector = () => {
    if (onOpenImagingStudySelector) onOpenImagingStudySelector();
  };

  useEffect(() => {
    if (uploadedFiles) {
      onUpload(uploadedFiles);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadedFiles]);

  return (
    <Grid container className="text-left">
      <Grid item xs={12}>
        <Typography className={`${classes.title} mb-1`}>You do not have any Imaging studies on record yet.</Typography>
      </Grid>
      <Grid item container xs={6} className="pr-1 right-separator">
        <Grid item xs={12} className="mb-2">
          <Typography className={classes.instruction}>
            You can now go ahead and upload your Imaging Studies which will be safely stored on our system to be viewed anytime.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {workspaceMainFileType === 'dicom' ? (
            <>
              <input onChange={handleFileChange} multiple directory="" webkitdirectory="" moxdirectory="" hidden id="raised-button-study" type="file" />
              <label htmlFor="raised-button-study">
                <LoadingButton
                  onClick={handleUploadButtonClick}
                  color="primary"
                  variant="contained"
                  style={{ width: '245px' }}
                  size="small"
                  component="span"
                  loading$={isSubmitting$}>
                  Upload my first Imaging Study
                </LoadingButton>
              </label>
            </>
          ) : null}

          {workspaceMainFileType === 'any' ? (
            <LoadingButton
              onClick={handleOpenImagingStudySelector}
              color="primary"
              variant="contained"
              style={{ width: '245px' }}
              size="small"
              component="span"
              loading$={isSubmitting$}>
              Upload my first Imaging Study
            </LoadingButton>
          ) : null}
        </Grid>
      </Grid>
      <Grid item container xs={6} className="pl-1">
        <Grid item xs={12} className="mb-2">
          <Typography className={classes.instruction}>Alternatively you can upload your Imaging study and have a personalized video report created.</Typography>
        </Grid>
        <Grid item xs={12}>
          <Button color="primary" variant="contained" style={{ width: '245px' }} size="small" onClick={OnRequestVideo}>
            {requestButtonText}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
